import { render } from "./OnlineOrderTest.vue?vue&type=template&id=f7fe9dd6&scoped=true"
import script from "./OnlineOrderTest.vue?vue&type=script&lang=js"
export * from "./OnlineOrderTest.vue?vue&type=script&lang=js"

import "./OnlineOrderTest.vue?vue&type=style&index=0&id=f7fe9dd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f7fe9dd6"

export default script